import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'array',
	standalone: true,
})
export class ArrayPipe implements PipeTransform {
	transform<T extends Array<any>>(value: T, method: keyof T, ...args: any[]): any {
		if (!Array.isArray(value)) {
			throw new Error('Input value must be an array');
		}

		const arrayMethodOrProperty = value[method];

		if (typeof arrayMethodOrProperty === 'function') {
			return arrayMethodOrProperty.apply(value, args);
		} else {
			return arrayMethodOrProperty;
		}
	}
}
